import {
    IProfileChild,
    IProfileOptionsResponse,
    IUserProfileUpdateRequest,
} from '@kcftech/prometheustypescriptapiclient';
import { CollapsiblePane } from 'components/expandable_pane/CollapsiblePane';
import { PaneSection } from 'components/expandable_pane/PaneSection';
import { ProfileSettingDropdownInlineEditor } from 'components/inline_edit/ProfileSettingDropdownInlineEditor';
import { useState } from 'react';

export type DateTimeOptionsPaneProps = Readonly<{
    options: IProfileOptionsResponse;
    profile: IProfileChild;
    className?: string;
    onChange: (updates: Partial<IUserProfileUpdateRequest>) => void;
}>;

export function DateTimeOptionsPane({
    options: { DateFormats, TimeFormats, TimeZones },
    className,
    profile,
    onChange,
}: DateTimeOptionsPaneProps) {
    const [expanded, setExpanded] = useState(false);

    return (
        <CollapsiblePane
            expanded={expanded}
            onChange={setExpanded}
            className={className}
            title="Date/Time Format"
        >
            <PaneSection label="Date Format Type">
                <ProfileSettingDropdownInlineEditor
                    options={DateFormats}
                    value={
                        DateFormats.find(
                            (option) => option.Value === profile.DateFormatCode
                        ) ?? DateFormats[0]
                    }
                    onConfirm={(value) => onChange({ DateFormat: value?.Value })}
                />
            </PaneSection>
            <PaneSection label="Time Format Type">
                <ProfileSettingDropdownInlineEditor
                    options={TimeFormats}
                    value={
                        TimeFormats.find(
                            (option) => option.Value === profile.TimeFormatCode
                        ) ?? TimeFormats[0]
                    }
                    onConfirm={(value) => onChange({ TimeFormat: value?.Value })}
                />
            </PaneSection>
            <PaneSection label="Time Zone">
                <ProfileSettingDropdownInlineEditor
                    options={TimeZones}
                    value={
                        TimeZones.find(
                            (option) => option.Value === profile.TimeZoneCode
                        ) ?? TimeZones[0]
                    }
                    onConfirm={(value) => onChange({ TimeZone: value?.Value })}
                />
            </PaneSection>
        </CollapsiblePane>
    );
}
